import JustValidate from 'just-validate';

const privilegeActivation = document.getElementById('privilege_activation');
const validator = new JustValidate('#privilege_activation');
window.onload = function () {
  validator
    .addField('#priv-act-cmc', [
      {
        rule: 'required',
        errorMessage: 'CMC kod je obavezan',
      },
    ])

    .addField('#priv-act-email', [
      {
        rule: 'required',
        errorMessage: 'E-mail je obavezan',
      },
      {
        rule: 'email',
        errorMessage: 'Email adresa koju ste uneli je nevažeća.',
      },
    ])

    .addField('#priv-act-terms', [
      {
        rule: 'required',
        errorMessage: 'Ovo je obavezno polje.',
      },
    ])
    .addField('#priv-act-privacy', [
      {
        rule: 'required',
        errorMessage: 'Ovo je obavezno polje.',
      },
    ])

    .addField('#priv-act-password', [
      {
        rule: 'required',
        errorMessage: 'Lozinka je obavezna',
      },
      {
        rule: 'minLength',
        value: 8,
        errorMessage: 'Lozinka mora da ima minimalno 8 karaktera.',
      },
    ])
    .addField('#priv-act-password-confirmation', [
      {
        rule: 'required',
        errorMessage: 'Lozinka je obavezna',
      },
      {
        rule: 'minLength',
        value: 8,
        errorMessage: 'Lozinka mora da ima minimalno 8 karaktera.',
      },
      {
        validator: (value, fields) => {
          if (
            fields['#priv-act-password'] &&
            fields['#priv-act-password'].elem
          ) {
            const repeatPasswordValue =
              fields['#priv-act-password'].elem.value;

            return value === repeatPasswordValue;
          }

          return true;
        },
        errorMessage: 'Lozinke se ne podudaraju. Pokušajte ponovo.',
      },
    ]).onSuccess((() => {
      privilegeActivation.submit()
    }))
};

// Make password visible
const seePassword = document.querySelector(".js_see_password");
const passwordInput = document.querySelector(".js_password");
const passwordInputConfirmation = document.querySelector(".js_password_confirmation");

if (seePassword) {
  seePassword.addEventListener('click', () => {
    if (passwordInput.getAttribute("type") === "password") {
      passwordInput.setAttribute("type", "text");
      passwordInputConfirmation.setAttribute("type", "text");
      seePassword.classList.add('visible');
    } else {
      passwordInput.setAttribute("type", "password");
      passwordInputConfirmation.setAttribute("type", "password");
      seePassword.classList.remove('visible');
    }
  })
}

// Toggle aditional data
const privilegeActToggle = document.getElementById("priv-act-toggle");
const privilegeActData = document.getElementById("priv-act-toggle_data");
const privActArrow = document.getElementById('priv-act-arrow');

privilegeActToggle.addEventListener("click", function (e) {
  // Toggle max-height animation
  privilegeActData.classList.toggle('max-h-0');
  privilegeActData.classList.toggle('max-h-s1000');

  privActArrow.classList.toggle('rotate-[0deg]')
  privActArrow.classList.toggle('rotate-[180deg]')
});